import { z } from 'zod';

/* 
    GraphQL Errors should be defined according to this spec: https://spec.graphql.org/draft/#sec-Errors.Error-Result-Format
    Example schema:
    z.object({
        // this is an object for additional fields to allow custom fields (https://spec.graphql.org/draft/#sec-Extensions)
        extensions: z.record(z.any()).optional(),
        locations: z
            .array(z.object({ column: z.number().positive().min(1), line: z.number().positive().min(1) }))
            .optional(),
        message: z.string(),
        path: z.array(z.string()).optional(),
    });
 */

/*
    EUROPACE API defines responses for GraphQL errors in the following way (https://docs.api.europace.de/privatkredit/graphql/#error-handling):
	{
		"data": {
            [key]: {
                "id": string,
                "messages": string[]
            }
        },
        "errors": [
        	{
			  "message": "Validation error of type FieldUndefined: Field 'vorgangsnummerr' in type 'Vorgang' is undefined @ 'vorgang/vorgangsnummerr'",
			  "locations": [
				{
				  "line": 1,
				  "column": 89
				}
			  ],
			  "description": "Field 'vorgangsnummerr' in type 'Vorgang' is undefined",
			  "validationErrorType": "FieldUndefined",
			  "queryPath": [
				"vorgang",
				"vorgangsnummerr"
			  ],
			  "errorType": "ValidationError"
			},
			{
			  "message": MESSAGE, // i guess it's a string
			  "status": STATUS_CODE // i guess it's a number like the http status codes
			}
		]
	}

*/

export const schemaErrorUnprocessable = z.object({
    // this is an additional field which is discouraged by the spec but is still sent by Europace
    description: z.string().optional(),
    // this is an additional field which is discouraged by the spec but is still sent by Europace
    errorType: z.literal('ValidationError'),
    locations: z.array(z.object({ column: z.number(), line: z.number() })).optional(),
    // according to the spec this should be required
    message: z.string().optional(),
    // this a violation of the spec but is still sent by Europace
    queryPath: z.array(z.string()).optional(),
    // this is an additional field which is discouraged by the spec but is still sent by Europace
    validationErrorType: z.string().optional(),
});

export type SchemaErrorUnprocessable = z.infer<typeof schemaErrorUnprocessable>;
